import { render, staticRenderFns } from "./RegularPlanetTable.vue?vue&type=template&id=0751d24e&"
import script from "./RegularPlanetTable.vue?vue&type=script&lang=js&"
export * from "./RegularPlanetTable.vue?vue&type=script&lang=js&"
import style0 from "./RegularPlanetTable.vue?vue&type=style&index=0&id=0751d24e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports